<template>
  <el-scrollbar>
  <router-view />
  </el-scrollbar>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>

</style>
